import React, {useEffect} from 'react';
import Tabs from "rc-tabs";
import {Box, Drawer} from '@mui/material';

import StylesPanel from './StylesPanel';
import {SettingsPanel} from "./SettingsPanel";
import Button from "../../../components/button";
import {TemplatesPanel} from "./TemplatesPanel";
import TabPane from "rc-tabs/lib/TabPanelList/TabPane";
import ConfigurationPanel from './ConfigurationPanel';
import {
    setSelectedBlockId,
    setSidebarTab, useDocument,
    useInspectorDrawerOpen,
    useSelectedSidebarTab
} from "../documents/editor/EditorContext";
import {useNavigate} from "react-router-dom";
import {useManagerContext} from "../../../sections/emails/ManagerContext";
import Icon from "../../../components/icon";

export const INSPECTOR_DRAWER_WIDTH = 380;

export default function InspectorDrawer() {

    const navigate = useNavigate();
    const document = useDocument();
    const {onSave, email, errors, isLoading} = useManagerContext();


    const selectedSidebarTab = useSelectedSidebarTab();
    const inspectorDrawerOpen = useInspectorDrawerOpen();
    const hasOriginError = errors && Object.keys(errors).some(key => key.startsWith("origin."));

    const settingsTab = !hasOriginError ? 'Settings' : <span className="error">{'⛔ Settings'}</span>


    const createNew = () => navigate('/emails/new')

    useEffect(() => {
        setSidebarTab('styles')
        setSelectedBlockId(null)
    }, [email]);


    useEffect(() => {
    }, [document])

    return (
        <Drawer
            variant="persistent"
            anchor="right"
            open={inspectorDrawerOpen}
            sx={{
                width: inspectorDrawerOpen ? INSPECTOR_DRAWER_WIDTH : 0,
            }}
        >
            <Box sx={{width: INSPECTOR_DRAWER_WIDTH, borderBottom: 1, borderColor: 'divider'}}>
                <Box px={2} className="sidebar-tools" display="flex" alignItems="center" justifyContent="right" backgroundColor="#f3f4ff">
                    <Button isReady={!isLoading} size="sm" color="secondary" label="Create new" className="me-2" onClick={createNew}/>
                    <Button isReady={!isLoading} size="sm" color="primary" label="Save" onClick={onSave}/>
                </Box>
            </Box>
            <Box className="editor-sidebar">
                {isLoading && <div className="white-mask"/>}
                {!isLoading && <Box sx={{width: INSPECTOR_DRAWER_WIDTH, height: 49}}>
                    <Box px={2} className="editor-sidebar">
                        <Tabs activeKey={selectedSidebarTab} className="mt-4" onTabClick={ev => setSidebarTab(ev)}>
                            <TabPane forceRender={true} key={'settings'} tabKey={'settings'} tab={settingsTab}>
                                <SettingsPanel/>
                            </TabPane>
                            <TabPane forceRender={true} key={'styles'} tabKey={'styles'} tab="Styles">
                                <StylesPanel/>
                            </TabPane>
                            <TabPane forceRender={true} key={'block-configuration'} tabKey={'block-configuration'} tab="Inspect">
                                <ConfigurationPanel/>
                            </TabPane>
                            <TabPane forceRender={false} key={'templates'} tabKey={'templates'} tab="Templates">
                                <TemplatesPanel/>
                            </TabPane>
                        </Tabs>
                    </Box>
                </Box>}
            </Box>
        </Drawer>
    );
}
